import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import bs from './locales/bs.json'
import hr from './locales/hr.json'
import sr from './locales/sr.json'
import de from './locales/de.json'
import { ALL_UI_PACKS } from './packs'
import { ensureLocale } from './loadLocale'

export { ALL_UI_PACKS, STABLE_UI, BETA_UI, RTL_LANGS, uiTier } from './packs'

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    bs: { translation: bs },
    hr: { translation: hr },
    sr: { translation: sr },
    de: { translation: de },
  },
  lng: 'bs',
  fallbackLng: {
    ...Object.fromEntries([...ALL_UI_PACKS].map((code) => [code, ['en']])),
    default: ['en'],
  },
  // Allow unknown codes briefly; ensureLocale + changeUiLanguage gate packs
  supportedLngs: [...ALL_UI_PACKS, 'cimode'],
  nonExplicitSupportedLngs: true,
  load: 'languageOnly',
  interpolation: { escapeValue: false },
  returnNull: false,
  returnEmptyString: true,
  parseMissingKeyHandler: (key) => {
    if (import.meta.env.DEV) {
      console.warn(`[i18n] missing key: ${key}`)
    }
    return key
  },
})

/** Ensure pack JSON is loaded before language switch (beta packs). */
export async function changeUiLanguage(code: string): Promise<void> {
  const base = (code.split('-')[0] || code).toLowerCase()
  if (ALL_UI_PACKS.has(base)) {
    await ensureLocale(base)
  }
  await i18n.changeLanguage(ALL_UI_PACKS.has(base) ? base : 'en')
}

export default i18n
